
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.512 7.315l-1.774 6.759v-8.45H16.1a1.69 1.69 0 00-1.69-1.69H8.497l-1.69-1.689h-5.07a1.69 1.69 0 00-1.69 1.69v10.139a1.69 1.69 0 001.69 1.69h12.674c.76 0 1.436-.507 1.605-1.268l1.944-7.181H3.512m10.9 6.759H3.426l1.352-5.07h10.984z"}})])
          )
        }
      }
    